/* ═══════════════════════════════════════════════════════
   WisdomTech — wisdomtech.js
   Loaded at end of <body> — no defer, no DOMContentLoaded needed
   ═══════════════════════════════════════════════════════ */

/* ─── SVG ICONS ─── */
function catSVG(cat, cls) {
  var c = (cat || '').toLowerCase();
  var k = (cls !== undefined) ? cls : 'psvg';
  var s = 'class="' + k + '" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"';
  if (c.indexOf('cable') >= 0)       return '<svg ' + s + '><path d="M16 20L16 44M20 20L20 44M24 20L24 44"/><rect x="12" y="16" width="16" height="6" rx="2"/><path d="M28 22L48 22L48 42L28 42"/><path d="M40 32L52 32M48 28L52 32L48 36"/></svg>';
  if (c.indexOf('mother') >= 0)      return '<svg ' + s + '><rect x="10" y="10" width="44" height="44" rx="3"/><rect x="16" y="16" width="14" height="14" rx="1"/><rect x="34" y="16" width="14" height="8" rx="1"/><rect x="16" y="34" width="6" height="14" rx="1"/><rect x="25" y="34" width="6" height="14" rx="1"/></svg>';
  if (c.indexOf('monitor') >= 0 || c.indexOf('display') >= 0) return '<svg ' + s + '><rect x="4" y="8" width="56" height="36" rx="3"/><line x1="4" y1="38" x2="60" y2="38"/><path d="M24 44L26 54L38 54L40 44"/><line x1="20" y1="54" x2="44" y2="54"/></svg>';
  if (c.indexOf('network') >= 0 || c.indexOf('wifi') >= 0)    return '<svg ' + s + '><path d="M32 46Q32 28 32 18"/><path d="M18 30Q24 18 32 18Q40 18 46 30"/><path d="M10 22Q20 8 32 8Q44 8 54 22"/><circle cx="32" cy="50" r="3" fill="currentColor"/><rect x="20" y="54" width="24" height="7" rx="2"/></svg>';
  if (c.indexOf('storage') >= 0 || c.indexOf('ssd') >= 0 || c.indexOf('dvd') >= 0) return '<svg ' + s + '><rect x="8" y="20" width="48" height="24" rx="3"/><circle cx="22" cy="32" r="5"/><circle cx="22" cy="32" r="2"/><path d="M36 26L52 26M36 32L48 32M36 38L52 38"/></svg>';
  if (c.indexOf('gpu') >= 0 || c.indexOf('video') >= 0)       return '<svg ' + s + '><rect x="6" y="18" width="52" height="28" rx="3"/><rect x="12" y="24" width="18" height="16" rx="2"/><circle cx="21" cy="32" r="5"/><circle cx="21" cy="32" r="2"/></svg>';
  if (c.indexOf('server') >= 0 || c.indexOf('rack') >= 0)     return '<svg ' + s + '><rect x="4" y="12" width="56" height="11" rx="2"/><rect x="4" y="26" width="56" height="11" rx="2"/><rect x="4" y="40" width="56" height="11" rx="2"/><circle cx="53" cy="17.5" r="2"/><circle cx="53" cy="31.5" r="2"/><circle cx="53" cy="45.5" r="2"/></svg>';
  if (c.indexOf('case') >= 0 || c.indexOf('tower') >= 0)      return '<svg ' + s + '><rect x="14" y="4" width="30" height="56" rx="3"/><rect x="18" y="10" width="10" height="8" rx="1"/><line x1="18" y1="28" x2="38" y2="28"/><line x1="18" y1="36" x2="38" y2="36"/></svg>';
  if (c.indexOf('speaker') >= 0 || c.indexOf('spk') >= 0)     return '<svg ' + s + '><circle cx="32" cy="30" r="20"/><circle cx="32" cy="30" r="9"/><circle cx="32" cy="30" r="3"/></svg>';
  if (c.indexOf('psu') >= 0 || c.indexOf('power') >= 0)       return '<svg ' + s + '><rect x="8" y="14" width="48" height="36" rx="3"/><circle cx="20" cy="32" r="8"/><circle cx="20" cy="32" r="3"/><path d="M32 22L54 22M32 28L52 28M32 34L54 34"/></svg>';
  return '<svg ' + s + '><rect x="4" y="8" width="56" height="36" rx="3"/><line x1="4" y1="38" x2="60" y2="38"/><path d="M24 44L26 54L38 54L40 44"/><line x1="20" y1="54" x2="44" y2="54"/></svg>';
}

/* ─── CART STATE ─── */
var cart = [];
function fmtP(n) { return '$' + (+n).toFixed(2); }
function cartTotal() { return cart.reduce(function(s,i){ return s + i.price * i.qty; }, 0); }

/* ─── RENDER CART ─── */
function renderCart() {
  var list  = document.getElementById('cart-items-list');
  var empty = document.getElementById('cart-empty');
  var foot  = document.getElementById('drawer-foot');
  var badge = document.getElementById('cart-count');
  var count = cart.reduce(function(s,i){ return s + i.qty; }, 0);
  if (badge) { badge.textContent = count; badge.style.display = count > 0 ? 'flex' : 'none'; }
  if (!list) return;
  if (cart.length === 0) {
    if (empty) empty.style.display = 'block';
    list.innerHTML = '';
    if (foot) foot.style.display = 'none';
    return;
  }
  if (empty) empty.style.display = 'none';
  if (foot)  foot.style.display  = 'block';
  var totalEl = document.getElementById('cart-total-disp');
  if (totalEl) totalEl.textContent = fmtP(cartTotal());
  list.innerHTML = cart.map(function(item, idx) {
    var icon  = catSVG(item.cat || 'Electronics', '').replace('<svg ', '<svg width="30" height="30" style="color:var(--blue);opacity:.7" ');
    var thumb = item.image ? '<img src="' + item.image + '" style="width:56px;height:56px;object-fit:contain;padding:4px">' : icon;
    return '<div class="cart-item">'
      + '<div class="ci-thumb">' + thumb + '</div>'
      + '<div class="ci-info">'
        + '<div class="ci-vendor">' + (item.brand || '') + '</div>'
        + '<div class="ci-name">'   + item.name          + '</div>'
        + '<div class="ci-price">'  + fmtP(item.price)   + '</div>'
        + '<div class="ci-qty">'
          + '<button onclick="chgQty(' + idx + ',-1)">&#8722;</button>'
          + '<span>' + item.qty + '</span>'
          + '<button onclick="chgQty(' + idx + ',1)">&#43;</button>'
        + '</div>'
      + '</div>'
      + '<button class="ci-rm" onclick="rmItem(' + idx + ')">&#215;</button>'
    + '</div>';
  }).join('');
}

function chgQty(idx, d) {
  var item = cart[idx]; if (!item) return;
  var newQty = item.qty + d;
  if (window.Shopify && item.key) {
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: item.key, quantity: Math.max(0, newQty)}) }).catch(function(){});
  }
  if (newQty <= 0) cart.splice(idx, 1); else cart[idx].qty = newQty;
  renderCart();
}

function rmItem(idx) {
  var item = cart[idx]; if (!item) return;
  if (window.Shopify && item.key) {
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: item.key, quantity: 0}) }).catch(function(){});
  }
  cart.splice(idx, 1);
  renderCart();
}

function clearCart() { cart = []; renderCart(); }

/* ─── CART DRAWER ─── */
function openCart() {
  if (window.Shopify) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(data){
      cart = data.items.map(function(item){
        return {
          id:        item.id,
          variantId: item.variant_id,
          key:       item.key,
          name:      item.product_title,
          brand:     item.vendor || '',
          cat:       item.product_type || 'Electronics',
          price:     item.price / 100,
          qty:       item.quantity,
          image:     item.featured_image ? item.featured_image.url : null
        };
      });
      renderCart();
    }).catch(function(){ renderCart(); });
  } else {
    renderCart();
  }
  var o = document.getElementById('wt-overlay'); if (o) o.classList.add('open');
  var d = document.getElementById('wt-drawer');  if (d) d.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  var o = document.getElementById('wt-overlay'); if (o) o.classList.remove('open');
  var d = document.getElementById('wt-drawer');  if (d) d.classList.remove('open');
  document.body.style.overflow = '';
}

/* ─── CHECKOUT MODAL ─── */
function openCheckout() {
  if (cart.length === 0) return;
  updateSummary();
  var o = document.getElementById('co-overlay');      if (o) o.classList.add('open');
  var f = document.getElementById('co-form-content'); if (f) f.style.display = 'block';
  var s = document.getElementById('co-success');      if (s) s.classList.remove('show');
  document.body.style.overflow = 'hidden';
}

function closeCheckout() {
  var o = document.getElementById('co-overlay'); if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

function updateSummary() {
  var sub = cartTotal(), tax = sub * 0.13, grand = sub + tax;
  function set(id, v) { var el = document.getElementById(id); if (el) el.textContent = v; }
  set('co-sub', fmtP(sub)); set('co-tax', fmtP(tax));
  set('co-grand', fmtP(grand)); set('co-order-total', fmtP(grand));
  var si = document.getElementById('co-summary-items');
  if (!si) return;
  si.innerHTML = cart.map(function(item){
    var icon  = catSVG(item.cat||'Electronics','').replace('<svg ','<svg width="24" height="24" style="color:var(--blue);opacity:.65" ');
    var thumb = item.image ? '<img src="' + item.image + '" style="width:100%;height:100%;object-fit:contain;padding:4px">' : icon;
    return '<div class="co-item">'
      + '<div class="co-item-badge">'
        + '<div class="co-item-img">' + thumb + '</div>'
        + '<span class="co-item-qty">' + item.qty + '</span>'
      + '</div>'
      + '<div class="co-item-info">'
        + '<div class="co-item-name">' + item.name + '</div>'
        + '<div class="co-item-sub">' + (item.cat||'') + ' &middot; ' + (item.brand||'') + '</div>'
      + '</div>'
      + '<span class="co-item-price">' + fmtP(item.price * item.qty) + '</span>'
    + '</div>';
  }).join('');
}

function placeOrder() {
  var f = document.getElementById('co-form-content'); if (f) f.style.display = 'none';
  var s = document.getElementById('co-success');      if (s) s.classList.add('show');
}

function setPayTab(btn, panel) {
  document.querySelectorAll('.pay-tab').forEach(function(t){ t.classList.remove('active'); });
  btn.classList.add('active');
  ['card','paypal','crypto'].forEach(function(p){
    var el = document.getElementById('pay-panel-' + p);
    if (el) el.style.display = (p === panel) ? 'block' : 'none';
  });
}

function expressPayClick(btn, method) { openCheckout(); setTimeout(placeOrder, 400); }
function fmtCard(el)   { var v=el.value.replace(/\D/g,'').substring(0,16); el.value=v.replace(/(.{4})/g,'$1 ').trim(); }
function fmtExpiry(el) { var v=el.value.replace(/\D/g,'').substring(0,4); if(v.length>2)v=v.slice(0,2)+' / '+v.slice(2); el.value=v; }

/* ─── TP-LINK MODAL ─── */
function openTPLink()  { var el=document.getElementById('tpl-overlay'); if(el){el.classList.add('open');    document.body.style.overflow='hidden';} }
function closeTPLink() { var el=document.getElementById('tpl-overlay'); if(el){el.classList.remove('open'); document.body.style.overflow='';} }

function addTPLinkToCart(name, cat, price, btn) {
  var ex = cart.find(function(i){ return i.name === name; });
  if (ex) ex.qty++; else cart.push({id: Date.now(), name: name, cat: cat, brand:'TP-Link', price: price, qty:1});
  renderCart();
  var orig = btn.innerHTML;
  btn.innerHTML = '&#10003; Added'; btn.style.background = '#28cd41';
  setTimeout(function(){ btn.innerHTML = orig; btn.style.background = ''; }, 1400);
  closeTPLink();
  setTimeout(openCart, 300);
}

/* ─── ADD TO SHOPIFY CART (AJAX) ─── */
function wtAddItem(variantId, btn) {
  if (!variantId) return;
  var orig = btn ? btn.innerHTML : '';
  if (btn) btn.disabled = true;

  if (window.Shopify) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: parseInt(variantId, 10), quantity: 1})
    }).then(function(r){
      if (!r.ok) throw new Error('fail');
      if (btn) {
        btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="11" height="11"><path d="M2 8l4 4 8-8"/></svg>Added';
        btn.style.background = '#28cd41';
        setTimeout(function(){ btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 1400);
      }
      openCart();
    }).catch(function(){
      if (btn) { btn.innerHTML = 'Error'; btn.style.background = '#ff3b30'; btn.disabled = false; }
      setTimeout(function(){ if(btn){ btn.innerHTML = orig; btn.style.background = ''; } }, 1500);
    });
  } else {
    var name  = btn ? (btn.dataset.name  || 'Product') : 'Product';
    var price = btn ? parseFloat(btn.dataset.price || '0') : 0;
    var cat   = btn ? (btn.dataset.cat   || 'Electronics') : 'Electronics';
    var brand = btn ? (btn.dataset.brand || '') : '';
    var ex = cart.find(function(i){ return i.variantId == variantId; });
    if (ex) ex.qty++; else cart.push({id: Date.now(), variantId: variantId, name: name, brand: brand, cat: cat, price: price, qty:1});
    if (btn) {
      btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="11" height="11"><path d="M2 8l4 4 8-8"/></svg>Added';
      btn.style.background = '#28cd41';
      setTimeout(function(){ btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 1400);
    }
    openCart();
  }
}

/* ─── DEMO PRODUCTS ─── */
var DEMO_PRODUCTS = [
  {id:1, name:'Adaptec SAS SFF-8087 Cable',         brand:'Adaptec',        cat:'Cable',       price:45.18},
  {id:2, name:'ASRock A520M-HDV AMD AM4 mATX',      brand:'ASRock',         cat:'Motherboard', price:92.94},
  {id:3, name:'ASUS VA24DQ 23.8" FHD IPS',          brand:'ASUS',           cat:'Monitor',     price:183.39},
  {id:4, name:'ASUS VA27DQSB 27" FHD IPS',          brand:'ASUS',           cat:'Monitor',     price:268.70},
  {id:5, name:'ASUS TUF VG27AQ 27" Gaming 2K',      brand:'ASUS TUF',       cat:'Gaming',      price:457.83},
  {id:6, name:'ASUS PCE-AX58BT AX3000 WiFi 6',      brand:'ASUS',           cat:'Networking',  price:118.26},
  {id:7, name:'ASUS SDRW-08D2S-U Slim DVDRW',       brand:'ASUS',           cat:'Storage',     price:54.34},
  {id:8, name:'Fractal Define 7 Mid Tower EATX',     brand:'Fractal Design', cat:'Case',        price:305.82},
  {id:9, name:'CoolerMaster N200 mATX Tower',        brand:'CoolerMaster',   cat:'Case',        price:90.94},
  {id:10,name:'Creative Pebble Speaker White',        brand:'Creative',       cat:'Speaker',     price:32.14},
  {id:11,name:'Epower EP-600PM 600W PSU',             brand:'Epower',         cat:'PSU',         price:77.47},
  {id:12,name:'ASUS GT1030-2G-CSM 2GB GDDR5',       brand:'ASUS',           cat:'GPU',         price:172.46},
  {id:13,name:'Gigabyte GT710 2GB DDR3 HDMI',        brand:'Gigabyte',       cat:'GPU',         price:112.75},
  {id:14,name:'CHENBRO RM42300H02 4U Rackmount',     brand:'CHENBRO',        cat:'Server',      price:356.95},
  {id:15,name:'Finisar FTLX8574D3BCV SFP+ 10G',     brand:'Finisar',        cat:'Networking',  price:58.92},
  {id:16,name:'Fractal Core 1000 USB3 mATX',         brand:'Fractal Design', cat:'Case',        price:68.91},
  {id:17,name:'ASUS SDRW-08U9M-U Ultra-Slim DVDRW', brand:'ASUS',           cat:'Storage',     price:62.05},
  {id:18,name:'Gigabyte GT1030 2GB DDR4 HDMI',       brand:'Gigabyte',       cat:'GPU',         price:191.13},
  {id:19,name:'Fractal Meshify C ATX',               brand:'Fractal Design', cat:'Case',        price:147.91},
  {id:20,name:'Fractal Focus G Black ATX',           brand:'Fractal Design', cat:'Case',        price:92.77},
];

function addDemoItem(id, triggerEl) {
  var p = DEMO_PRODUCTS.find(function(x){ return x.id === id; });
  if (!p) return;
  var ex = cart.find(function(i){ return i.id === id; });
  if (ex) ex.qty++; else cart.push({id:p.id, name:p.name, brand:p.brand, cat:p.cat, price:p.price, qty:1});
  renderCart();
  var card   = triggerEl ? triggerEl.closest('.pcard') : null;
  var target = (card && card.querySelector('.padd')) || triggerEl;
  if (!target) return;
  var orig = target.innerHTML;
  target.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" width="11" height="11"><path d="M2 8l4 4 8-8"/></svg>Added';
  target.style.background = '#28cd41';
  setTimeout(function(){ target.innerHTML = orig; target.style.background = ''; }, 1400);
}

/* ─── BUILD DEMO GRID ─── */
function buildDemoGrid(grid) {
  DEMO_PRODUCTS.forEach(function(p) {
    var div = document.createElement('div');
    div.className = 'pcard';
    div.innerHTML = '<div class="pimg" data-demo-id="' + p.id + '" style="cursor:pointer">' + catSVG(p.cat) + '</div>'
      + '<span class="pcat">' + p.cat + '</span>'
      + '<div class="pbrand">' + p.brand + '</div>'
      + '<div class="pname">' + p.name + '</div>'
      + '<div class="pfoot">'
        + '<span class="pprice">' + fmtP(p.price) + '</span>'
        + '<button class="padd" data-demo-id="' + p.id + '">'
          + '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="11" height="11"><path d="M8 3v10M3 8h10"/></svg>Add'
        + '</button>'
      + '</div>';
    grid.appendChild(div);
  });
}

/* ─── SINGLE CLICK HANDLER ─── */
document.addEventListener('click', function(e) {

  /* 0. Product page form submit — don't intercept */
  if (e.target.closest && e.target.closest('form[action*="/cart/add"] button[type="submit"]')) {
    return;
  }

  /* 1. Shopify Add button: .padd with data-variant */
  var shopBtn = e.target.closest ? e.target.closest('.padd[data-variant]') : null;
  if (shopBtn) {
    e.preventDefault();
    wtAddItem(shopBtn.dataset.variant, shopBtn);
    return;
  }

  /* 2. Demo Add button: .padd with data-demo-id */
  var demoBtn = e.target.closest ? e.target.closest('.padd[data-demo-id]') : null;
  if (demoBtn) {
    e.preventDefault();
    addDemoItem(parseInt(demoBtn.dataset.demoId, 10), demoBtn);
    openCart();
    return;
  }

  /* 3. Product image click → find and click its add button */
  var pimg = e.target.closest ? e.target.closest('.pimg, .wt-pimg') : null;
  if (pimg) {
    e.preventDefault();
    var card = pimg.closest('.pcard');
    if (card) {
      var btn = card.querySelector('.padd:not([disabled])');
      if (btn) btn.click();
    }
    return;
  }

  /* 4. Checkout button */
  if (e.target.closest && e.target.closest('.btn-checkout')) {
    e.preventDefault();
    closeCart();
    openCheckout();
    return;
  }

  /* 5. Overlay clicks to close */
  var coOv = document.getElementById('co-overlay');
  if (coOv && e.target === coOv) { closeCheckout(); return; }
  var tplOv = document.getElementById('tpl-overlay');
  if (tplOv && e.target === tplOv) { closeTPLink(); return; }
  var wtOv = document.getElementById('wt-overlay');
  if (wtOv && e.target === wtOv) { closeCart(); return; }
});

/* ─── INIT ─── */
(function init() {
  var grid = document.getElementById('pgrid');
  if (grid && grid.querySelectorAll('.pcard').length === 0) {
    buildDemoGrid(grid);
  }
  renderCart();
})();